import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { StoryApi } from './story-api';

@NgModule({ imports: [], providers: [
        StoryApi,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class StoryApiModule {
}
